/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Team
 */
export interface Team {
    /**
     * Team Basket API ID
     * @type {number}
     * @memberof Team
     */
    basketApiId: number;
    /**
     * Team College Basketball Data API ID
     * @type {number}
     * @memberof Team
     */
    cbbdApiId: number;
    /**
     * Team created at
     * @type {Date}
     * @memberof Team
     */
    createdAt: Date;
    /**
     * Team ESPN ID
     * @type {number}
     * @memberof Team
     */
    espnId: number;
    /**
     * Team external URL, link to their athletics website
     * @type {string}
     * @memberof Team
     */
    externalUrl: string;
    /**
     * Team ID
     * @type {number}
     * @memberof Team
     */
    id: number;
    /**
     * Team image URL
     * @type {string}
     * @memberof Team
     */
    imageUrl: string;
    /**
     * Team name
     * @type {string}
     * @memberof Team
     */
    name: string;
    /**
     * Team NCAA SEO
     * @type {string}
     * @memberof Team
     */
    ncaaSeo: string;
    /**
     * Team primary color
     * @type {string}
     * @memberof Team
     */
    primaryColor: string;
    /**
     * Team secondary color
     * @type {string}
     * @memberof Team
     */
    secondaryColor: string;
    /**
     * Team short name
     * @type {string}
     * @memberof Team
     */
    shortName: string;
    /**
     * Team updated at
     * @type {Date}
     * @memberof Team
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the Team interface.
 */
export function instanceOfTeam(value: object): value is Team {
    if (!('basketApiId' in value) || value['basketApiId'] === undefined) return false;
    if (!('cbbdApiId' in value) || value['cbbdApiId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('espnId' in value) || value['espnId'] === undefined) return false;
    if (!('externalUrl' in value) || value['externalUrl'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ncaaSeo' in value) || value['ncaaSeo'] === undefined) return false;
    if (!('primaryColor' in value) || value['primaryColor'] === undefined) return false;
    if (!('secondaryColor' in value) || value['secondaryColor'] === undefined) return false;
    if (!('shortName' in value) || value['shortName'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function TeamFromJSON(json: any): Team {
    return TeamFromJSONTyped(json, false);
}

export function TeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): Team {
    if (json == null) {
        return json;
    }
    return {
        
        'basketApiId': json['basket_api_id'],
        'cbbdApiId': json['cbbd_api_id'],
        'createdAt': (new Date(json['created_at'])),
        'espnId': json['espn_id'],
        'externalUrl': json['external_url'],
        'id': json['id'],
        'imageUrl': json['image_url'],
        'name': json['name'],
        'ncaaSeo': json['ncaa_seo'],
        'primaryColor': json['primary_color'],
        'secondaryColor': json['secondary_color'],
        'shortName': json['short_name'],
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function TeamToJSON(json: any): Team {
    return TeamToJSONTyped(json, false);
}

export function TeamToJSONTyped(value?: Team | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'basket_api_id': value['basketApiId'],
        'cbbd_api_id': value['cbbdApiId'],
        'created_at': value['createdAt'].toISOString(),
        'espn_id': value['espnId'],
        'external_url': value['externalUrl'],
        'id': value['id'],
        'image_url': value['imageUrl'],
        'name': value['name'],
        'ncaa_seo': value['ncaaSeo'],
        'primary_color': value['primaryColor'],
        'secondary_color': value['secondaryColor'],
        'short_name': value['shortName'],
        'updated_at': value['updatedAt'].toISOString(),
    };
}

